var _g, _g2, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcocuntBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "people",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.885 2.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.115,6.02a.706.706,0,0,0-.222,0,3.016,3.016,0,1,1,.222,0Z",
    fill: "none",
    stroke: "#1e163f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.035,5.764a6.574,6.574,0,0,0,4.6-.84,2.23,2.23,0,0,0,0-3.99A6.615,6.615,0,0,0,0,.105",
    transform: "translate(1.878 8.75)",
    fill: "none",
    stroke: "#1e163f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(2.336 2.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.905,6.02a.706.706,0,0,1,.222,0,3.016,3.016,0,1,0-.222,0Z",
    transform: "translate(1.724)",
    fill: "none",
    stroke: "#1e163f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.83,5.764a6.574,6.574,0,0,1-4.6-.84,2.23,2.23,0,0,1,0-3.99A6.615,6.615,0,0,1,5.865.105",
    transform: "translate(0 8.75)",
    fill: "none",
    stroke: "#1e163f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    "data-name": "Group",
    transform: "translate(9.371 11.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M3.115,6.02a.706.706,0,0,0-.222,0,3.016,3.016,0,1,1,.222,0Z",
    transform: "translate(1.514)",
    fill: "none",
    stroke: "#1e163f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1.234.927a2.23,2.23,0,0,0,0,3.99,6.624,6.624,0,0,0,6.79,0,2.23,2.23,0,0,0,0-3.99A6.677,6.677,0,0,0,1.234.927Z",
    transform: "translate(0 8.767)",
    fill: "none",
    stroke: "#1e163f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcocuntBlack);
export default __webpack_public_path__ + "static/media/acocuntBlack.8d5724fdad7959e43f2e9481d29a2c44.svg";
export { ForwardRef as ReactComponent };